import { render, staticRenderFns } from "./modalInfos.vue?vue&type=template&id=90af1552"
import script from "./modalInfos.vue?vue&type=script&lang=js"
export * from "./modalInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports